(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const media = window.matchMedia('(min-width: 769px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let ticking = false;

    const update = () => {
      ticking = false;
      const sections = document.querySelectorAll('[data-mj-soft-parallax="true"]');

      sections.forEach((section) => {
        if (!media.matches || reducedMotion.matches) {
          section.style.removeProperty('--mj-parallax-y');
          return;
        }

        const rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;

        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const clamped = Math.max(0, Math.min(1, progress));
        const offset = (clamped - 0.5) * 70;
        section.style.setProperty('--mj-parallax-y', `${offset.toFixed(1)}px`);
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);
    requestUpdate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-atelier-header"]) return;
  try {
    
(function() {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let closeTimer;

  function getFocusable(menu) {
    return Array.from(menu.querySelectorAll('summary, nav a')).filter(function(element) {
      return element.offsetParent !== null;
    });
  }

  function openMenu(menu) {
    clearTimeout(closeTimer);
    menu.classList.remove('ma-menu-closing');
    menu.setAttribute('open', '');
    document.documentElement.classList.add('ma-menu-open');
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        menu.classList.add('ma-menu-active');
        const firstLink = menu.querySelector('.ma-mobile-links a');
        if (firstLink) firstLink.focus({ preventScroll: true });
      });
    });
  }

  function closeMenu(menu, restoreFocus) {
    if (!menu) return;
    clearTimeout(closeTimer);
    menu.classList.add('ma-menu-closing');
    menu.classList.remove('ma-menu-active');
    document.documentElement.classList.remove('ma-menu-open');
    const finish = function() {
      menu.removeAttribute('open');
      menu.classList.remove('ma-menu-closing');
      if (restoreFocus) menu.querySelector('summary').focus({ preventScroll: true });
    };
    if (motion.matches) {
      finish();
    } else {
      closeTimer = window.setTimeout(finish, 640);
    }
  }

  document.addEventListener('click', function(event) {
    const summary = event.target.closest('.ma-mobile-menu summary');
    if (summary) {
      event.preventDefault();
      const menu = summary.closest('.ma-mobile-menu');
      if (menu.hasAttribute('open')) closeMenu(menu, true);
      else openMenu(menu);
      return;
    }
    const scrim = event.target.closest('.ma-mobile-scrim');
    if (scrim) closeMenu(scrim.closest('.ma-mobile-menu'), true);
  });

  document.addEventListener('keydown', function(event) {
    const menu = document.querySelector('.ma-mobile-menu[open]');
    if (!menu) return;
    if (event.key === 'Escape') {
      closeMenu(menu, true);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = getFocusable(menu);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!document.querySelector('.mc-hero')) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 900px)');
  const seen = new WeakSet();
  const intros = new WeakSet();
  const observed = new Map();
  const running = new Set();
  const ease = 'cubic-bezier(.22,.68,.22,1)';
  let observer;
  let cleanupDepth = () => {};
  const motion = (el, frames, duration = 800, delay = 0) => {
    if (!el || reduce.matches) return;
    const animation = el.animate(frames, { duration, delay, easing: ease, fill: 'both' });
    running.add(animation);
    animation.finished.then(() => {
      running.delete(animation);
      animation.cancel();
    }).catch(() => running.delete(animation));
    return animation;
  };
  const fade = (el, duration = 650, delay = 0) => motion(el, [{opacity:0},{opacity:1}], duration, delay);
  const enter = (el, x, scale = 1, duration = 850, delay = 0) => motion(el, [
    {opacity:0, transform:'translate3d(' + x + 'px,0,0) scale(' + scale + ')'},
    {opacity:1, transform:'translate3d(0,0,0) scale(1)'}
  ], duration, delay);
  const setupDepth = () => {
    cleanupDepth();
    if (reduce.matches || !desktop.matches || !('IntersectionObserver' in window)) return;
    const hero = document.querySelector('.mc-hero');
    const image = hero && hero.querySelector('.mc-hero-image');
    const orbit = hero && hero.querySelector('.mc-orbit');
    if (!image || !orbit) return;
    let frame = 0;
    let visible = true;
    const paint = () => {
      frame = 0;
      if (!visible || document.hidden) return;
      const box = hero.getBoundingClientRect();
      const depth = Math.min(1, Math.max(0, -box.top / (box.height * .85)));
      image.style.translate = (depth * 26).toFixed(2) + 'px ' + (-depth * 64).toFixed(2) + 'px';
      orbit.style.translate = (-depth * 12).toFixed(2) + 'px ' + (depth * 18).toFixed(2) + 'px';
    };
    const scroll = () => { if (visible && !frame) frame = requestAnimationFrame(paint); };
    const visibility = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) scroll();
    });
    visibility.observe(hero);
    addEventListener('scroll', scroll, {passive:true});
    addEventListener('resize', scroll, {passive:true});
    document.addEventListener('visibilitychange', scroll);
    paint();
    cleanupDepth = () => {
      visibility.disconnect();
      removeEventListener('scroll', scroll);
      removeEventListener('resize', scroll);
      document.removeEventListener('visibilitychange', scroll);
      cancelAnimationFrame(frame);
      image.style.removeProperty('translate');
      orbit.style.removeProperty('translate');
    };
  };
  const intro = hero => {
    if (intros.has(hero)) return;
    intros.add(hero);
    if (reduce.matches || scrollY > 120) return;
    const rich = desktop.matches;
    hero.dataset.mcMotion = 'hero';
    const title = hero.querySelector('h1');
    const kicker = hero.querySelector('.mc-kicker');
    fade(kicker, 650);
    motion(title, [{opacity:.55,transform:'translate3d(0,16px,0)'},{opacity:1,transform:'none'}], rich ? 950 : 680, 70);
    fade(hero.querySelector('.mc-hero-description'), 700, 130);
    fade(hero.querySelector('.mc-actions'), 550, 100);
    fade(hero.querySelector('.mc-hero-proof'), 650, 210);
    motion(hero.querySelector('.mc-hero-gallery'), [
      {transform:'translate3d(' + (rich ? 28 : 0) + 'px,0,0) scale(.972)'},
      {transform:'translate3d(0,0,0) scale(1)'}
    ], rich ? 1200 : 760);
    motion(hero.querySelector('.mc-hero-image'), [{transform:'scale(1.22)'},{transform:'scale(1.32)'}], rich ? 1400 : 850);
    motion(hero.querySelector('.mc-orbit'), [{opacity:.2,scale:.93},{opacity:1,scale:1}], rich ? 1300 : 800, 80);
    fade(hero.querySelector('.mc-gallery-label'), 600, 180);
    fade(hero.querySelector('.mc-hero-caption'), 600, 120);
    fade(hero.querySelector('.mc-gallery-side'), 700, 200);
    fade(hero.querySelector('.mc-hero-bottom'), 600, 220);
  };
  const reveal = (el, type) => {
    const rich = desktop.matches;
    if (type === 'category' || type === 'product' || type === 'journal') {
      const selector = type === 'category' ? '.mc-category' : type === 'product' ? '.mc-product' : '.ma-guide';
      const row = [...el.parentElement.querySelectorAll(selector)].filter(sibling => Math.abs(sibling.offsetTop - el.offsetTop) < 4);
      const column = row.indexOf(el);
      if (type === 'category') enter(el, rich ? -48 : -18, .992, rich ? 980 : 680, Math.max(0,column) * (rich ? 95 : 65));
      if (type === 'product') enter(el, rich ? 38 : 8, rich ? .985 : .968, rich ? 900 : 700, (rich ? row.length - 1 - column : column) * (rich ? 85 : 55));
      if (type === 'journal') {
        if (rich) {
          enter(el.querySelector('.ma-guide-image'), -24, 1, 850, column * 85);
          [...el.children].filter(child => !child.classList.contains('ma-guide-image')).forEach(child => fade(child,680,column*85+95));
        } else enter(el, -14, 1, 650);
      }
    } else if (type === 'story-art') {
      enter(el, rich ? -54 : 0, rich ? .995 : .98, rich ? 1120 : 780);
    } else if (type === 'story-copy') {
      if (rich) enter(el, 48, .995, 1080, 100); else fade(el, 720);
    } else if (type === 'manifesto') {
      motion(el.querySelector(':scope > div:not(.mc-manifesto-rings)'), [{opacity:.15,scale:.985},{opacity:1,scale:1}],rich?900:650,120);
      el.querySelectorAll('.mc-manifesto-rings span').forEach((ring,index) => motion(ring, [
        {opacity:0,translate:(index ? 1 : -1)*(rich ? 56 : 14)+'px 0',scale:rich?.88:.98},
        {opacity:1,translate:'0px 0px',scale:1}
      ],rich?1550:950,index*100));
    } else {
      fade(el, type === 'fit' ? 700 : 600);
    }
  };
  const register = (el, type) => {
    if (seen.has(el) || observed.has(el)) return;
    el.dataset.mcMotion = type;
    el.classList.add('mc-motion-target');
    if (reduce.matches || !observer) return;
    observed.set(el,type);
    if (el.getBoundingClientRect().top >= innerHeight * .92) el.classList.add('mc-motion-pending');
    observer.observe(el);
  };
  const setup = () => {
    if (!document.querySelector('.mc-hero')) return;
    setupDepth();
    document.querySelectorAll('.mc-hero').forEach(intro);
    if (!reduce.matches && 'IntersectionObserver' in window && !observer) {
      observer = new IntersectionObserver(entries => {
        const ready = entries.filter(entry => entry.isIntersecting).map(entry => ({el:entry.target,type:observed.get(entry.target)}));
        ready.forEach(({el}) => {
          observer.unobserve(el);
          observed.delete(el);
          el.classList.remove('mc-motion-pending');
          seen.add(el);
        });
        ready.forEach(({el,type}) => {
          const box = el.getBoundingClientRect();
          if (box.top > 40 && box.bottom > 140 && !el.contains(document.activeElement)) reveal(el,type);
        });
      },{threshold:.06,rootMargin:'0px 0px -8% 0px'});
    }
    const targets = {
      '.mc-heading-row,.ma-section-head':'heading',
      '.mc-category':'category',
      '.mc-fit':'fit',
      '.mc-product':'product',
      '.mc-story-art':'story-art',
      '.mc-story-copy':'story-copy',
      '.mc-manifesto':'manifesto',
      '.ma-guide':'journal',
      '.ma-final':'ending'
    };
    Object.entries(targets).forEach(([selector,type]) => document.querySelectorAll(selector).forEach(el=>register(el,type)));
  };
  const settle = root => {
    [...observed.keys()].forEach(el => {
      if (!root.contains(el) && !el.contains(root)) return;
      el.classList.remove('mc-motion-pending');
      observer?.unobserve(el);
      observed.delete(el);
      seen.add(el);
    });
    running.forEach(animation => {
      const target = animation.effect.target;
      if (root.contains(target) || target.contains(root)) animation.cancel();
    });
  };
  document.addEventListener('focusin', event => settle(event.target));
  document.addEventListener('pointerdown', event => settle(event.target), {passive:true});
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', event => {
    settle(event.target);
    setupDepth();
  });
  desktop.addEventListener('change', () => {
    running.forEach(animation=>animation.cancel());
    setupDepth();
  });
  reduce.addEventListener('change', () => {
    if (reduce.matches) {
      observer?.disconnect();
      observer = null;
      observed.forEach((type,el)=>el.classList.remove('mc-motion-pending'));
      observed.clear();
      running.forEach(animation=>animation.cancel());
    }
    setup();
  });
  addEventListener('pageshow', event => {
    if (event.persisted) {
      settle(document.querySelector('main'));
      setupDepth();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup,{once:true}); else setup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const setup = () => document.querySelectorAll('.mj-customer-reviews').forEach(section => {
    if (instances.has(section)) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 900px)');
    const controller = new AbortController();
    const running = new Set();
    let entranceObserver;
    let cleanupSwap = () => {};
    let initialized = false;
    let revealed = false;
    const animate = (element, frames, duration, delay = 0) => {
      if (!element || reduce.matches) return;
      const animation = element.animate(frames, {duration,delay,easing:'cubic-bezier(.22,.68,.22,1)',fill:'both'});
      running.add(animation);
      animation.finished.then(() => { running.delete(animation); animation.cancel(); }).catch(()=>running.delete(animation));
      return animation;
    };
    const protectNames = () => {
      section.querySelectorAll('.jdgm-carousel-item__reviewer-name, .jdgm-review-header .jm-text:first-of-type').forEach(nameElement => {
        const originalName = nameElement.dataset.mjOriginalName || nameElement.textContent.trim();
        if (!originalName) return;
        nameElement.dataset.mjOriginalName = originalName;
        const displayName = originalName.toLowerCase() === 'anonymous' ? 'Anonymous' : originalName.split(/\s+/)[0];
        const formattedName = displayName.charAt(0).toUpperCase() + displayName.slice(1);
        if (nameElement.textContent.trim() !== formattedName) nameElement.textContent = formattedName;
      });
    };
    const initializeCarousel = () => {
      protectNames();
      const items = [...section.querySelectorAll('.jdgm-carousel-item')];
      let previous = section.querySelector('.jdgm-carousel__left-arrow');
      let next = section.querySelector('.jdgm-carousel__right-arrow');
      const status = section.querySelector('.mj-review-status');
      if (initialized || !items.length || !previous || !next) return;
      initialized = true;
      const nativeControl = control => {
        if (control.tagName === 'BUTTON') return control;
        const button = document.createElement('button');
        [...control.attributes].forEach(attribute=>button.setAttribute(attribute.name,attribute.value));
        button.type = 'button';
        button.innerHTML = control.innerHTML;
        control.replaceWith(button);
        return button;
      };
      previous = nativeControl(previous);
      next = nativeControl(next);
      let active = 0;
      const setStatus = () => {
        if (status) status.textContent = section.dataset.reviewPosition.replace('[current]',active+1).replace('[total]',items.length);
      };
      const show = (index, direction = 0) => {
        cleanupSwap();
        const oldItem = items[active];
        active = (index + items.length) % items.length;
        const current = items[active];
        items.forEach((item,i) => {
          item.classList.toggle('mj-review-active', i === active);
          item.classList.remove('mj-review-leaving');
          item.setAttribute('aria-hidden',i === active ? 'false':'true');
          item.inert = i !== active;
        });
        setStatus();
        if (!direction || current === oldItem || reduce.matches) return;
        const distance = desktop.matches ? 38 : 20;
        oldItem.classList.add('mj-review-leaving');
        const exiting = animate(oldItem,[{opacity:1,transform:'translateX(0)'},{opacity:0,transform:'translateX('+(-direction*distance)+'px)'}],220);
        const entering = animate(current,[{opacity:0,transform:'translateX('+(direction*distance)+'px)'},{opacity:1,transform:'translateX(0)'}],desktop.matches?470:350,55);
        let timer;
        const finish = () => {
          clearTimeout(timer);
          exiting?.cancel();
          entering?.cancel();
          oldItem.classList.remove('mj-review-leaving');
        };
        cleanupSwap = finish;
        timer = setTimeout(()=>oldItem.classList.remove('mj-review-leaving'),225);
        exiting?.finished.then(()=>oldItem.classList.remove('mj-review-leaving')).catch(()=>{});
        entering?.finished.then(finish).catch(()=>{});
      };
      const activate = (event,direction) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        show(active+direction,direction);
      };
      [previous,next].forEach((control,index) => {
        control.setAttribute('role','button');
        control.setAttribute('aria-label',index ? section.dataset.reviewNext : section.dataset.reviewPrevious);
        control.setAttribute('tabindex','0');
        control.addEventListener('click',event=>activate(event,index?1:-1),{capture:true,signal:controller.signal});
        control.addEventListener('keydown',event=>{
          if (event.key === 'Enter' || event.key === ' ') activate(event,index?1:-1);
          if (event.key === 'ArrowRight') activate(event,1);
          if (event.key === 'ArrowLeft') activate(event,-1);
        },{capture:true,signal:controller.signal});
        control.addEventListener('keyup',event=>{
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },{capture:true,signal:controller.signal});
      });
      section.classList.add('mj-review-ready');
      show(0);
    };
    const reveal = () => {
      if (revealed) return;
      revealed = true;
      section.classList.add('mj-review-visible');
      if (reduce.matches || section.getBoundingClientRect().top < 40) return;
      const rich = desktop.matches;
      animate(section.querySelector('.mj-customer-reviews__header'),[{opacity:0},{opacity:1}],700);
      animate(section.querySelector('.jdgm-carousel-wrapper'),[{opacity:0},{opacity:1}],650,100);
      animate(section.querySelector('.mj-customer-reviews__trust-badge'),[{opacity:0},{opacity:1}],600,150);
      const layers = [
        ['.mj-review-mountain--far',-12,4,1050,0],
        ['.mj-review-mountain--middle',14,8,1300,50],
        ['.mj-review-mountain--near',-22,12,1500,90],
        ['.mj-review-mist:not(.mj-review-mist--low)',28,0,1700,120],
        ['.mj-review-mist--low',-18,0,1500,180]
      ];
      layers.forEach(([selector,x,y,duration,delay]) => animate(section.querySelector(selector),[
        {opacity:0,transform:'translate('+ (rich ? x : x*.4) +'px,'+(rich ? y : 0)+'px)'},
        {opacity:1,transform:'translate(0,0)'}
      ],rich?duration:1000,rich?delay:delay*.5));
    };
    initializeCarousel();
    const changes = new MutationObserver(initializeCarousel);
    changes.observe(section,{childList:true,subtree:true});
    if ('IntersectionObserver' in window && !reduce.matches) {
      entranceObserver = new IntersectionObserver(entries=>{
        if (entries.some(entry=>entry.isIntersecting)) {
          reveal();
          entranceObserver.disconnect();
        }
      },{threshold:.12});
      entranceObserver.observe(section);
    } else reveal();
    const settle = () => {
      cleanupSwap();
      running.forEach(animation=>animation.cancel());
    };
    reduce.addEventListener('change',()=>{
      if (reduce.matches) {
        entranceObserver?.disconnect();
        settle();
        reveal();
      }
    },{signal:controller.signal});
    desktop.addEventListener('change',settle,{signal:controller.signal});
    instances.set(section,()=>{
      controller.abort();
      changes.disconnect();
      entranceObserver?.disconnect();
      settle();
    });
  });
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll('.mj-customer-reviews').forEach(section=>{
      instances.get(section)?.();
      instances.delete(section);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup,{once:true}); else setup();
})();

  } catch(e) { console.error(e); }
})();
})();
